import { LinkOverrides } from '../types';

export const melioLinksOverrides: LinkOverrides = {
  helpCenter: 'https://melio.zendesk.com/hc/en-us',
  failedToCollectSupport: '',
};
